import React, { FC, useContext } from "react";
import { FABSProps, ItemProps } from "./FABS.types";
import styles from "./FABS.module.scss";
import FABContext from "./FABS.context";
import Tooltip from "../Tooltip";
import { Button } from "../index";

const Item: FC<ItemProps> = (props) => {
  const small = useContext(FABContext);
  if (small) {
    return (
      <Tooltip title={props.buttonProps.children.toString() ?? ""}>
        <Button {...{ ...props.buttonProps, children: undefined }} />
      </Tooltip>
    );
  }
  return <Button {...props.buttonProps} />;
};

const FABS: FC<FABSProps> & { Item: typeof Item } = ({
  children,
  small,
  absolute,
}: FABSProps) => {
  return (
    <div
      className={styles.FABS}
      style={{ position: absolute ? "absolute" : "fixed" }}
      data-testid="FABS"
    >
      <FABContext.Provider value={small ?? false}>
        {children}
      </FABContext.Provider>
    </div>
  );
};

FABS.Item = Item;

export default FABS;
